import React from 'react';
import classNames from 'classnames';

const CategoryGroup = ({ group, items, clickHandler }) => (
  <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6 list">
    <p className={classNames(['title', { 'md-hidden': group.length === 0 }])}>
      {group}
    </p>
    <ul>
      {(items || []).map(item => <li key={item.value}>
        <p className="small">
          <a onClick={clickHandler.bind(this, item)}>{item.label}</a>
        </p>
      </li>)}
    </ul>
  </div>
);

CategoryGroup.propTypes = {
  group: React.PropTypes.string.isRequired,
  items: React.PropTypes.arrayOf.isRequired,
  clickHandler: React.PropTypes.func.isRequired,
};

export default CategoryGroup;



// WEBPACK FOOTER //
// ./src/components/category-group/index.js